"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var htmlnavheader = `<li>
        <div class="user-view">
            <div class="background"><img src="img/loader_seq.gif"></div>
            <a href="#!user"><img class="circle" src="img/loader_seq.gif"></a>
            <a href="#!name"><span class="name">John Doe</span></a>
            <a href="#!email"><span class="email">jdandturk@gmail.com</span></a>
        </div>
    </li>`;
var htmlcombo = `<li>
        <div class="input-field">
            <select>
                <option value="1">Positive arc</option>
                <option value="2">Negative arc</option>
                <option value="2">Line</option>
            </select>
            <label>Line style</label>
        </div>
    </li>`;
var htmlbool = `<li>
        <div class="input-field-bool">
            <input type="checkbox" class="filled-in" id="filled-in-box" checked="checked" />
            <label for="filled-in-box">Filled in</label>
        </div>
    </li>`;
var htmlbutton = `<li><a class="waves-effect">Captions</a></li>`;
exports.htmlnav = `<ul id="slide-out" class="side-nav">
        <li class="no-padding">
            ${htmlnavheader}
            <li><div class="divider"></div></li>
            <ul class="collapsible collapsible-accordion">
                <li>
                    <a class="waves-effect" style="padding: 0 16px;" href="#!">
                        <i class="material-icons">file_upload</i>Upload skos || json || d3json || d3csv
                    </a>
                </li>
                <li>
                    <a class="collapsible-header waves-effect">
                        <i class="material-icons">code-setting</i>UnitDisk&lt;N&gt;
                    </a>
                    <div class="collapsible-body">
                        <ul>
                            <li><a class="waves-effect">Data source</a></li>
                            <li><a class="waves-effect">Renderer</a></li>
                            <li><a class="waves-effect">Layout</a></li>
                            <li><a class="waves-effect">Weight</a></li>
                        </ul>
                    </div>
                </li>

                <li>
                    <a class="collapsible-header waves-effect">
                        <i class="material-icons">toll</i>LayerStack&lt;N&gt;
                    </a>
                    <div class="collapsible-body">
                        <ul>
                            <li><div style="height:1.3em;"></div></li>
                            ${htmlcombo}
                            ${htmlcombo}
                            ${htmlbool}
                            <li><div style="height:.5em;"></div></li>
                        </ul>
                    </div>
                </li>

                <li>
                    <a class="collapsible-header waves-effect">
                        <i class="material-icons">layers</i>Layers
                    </a>
                    <div class="collapsible-body">
                        <ul>                            
                            <li><a class="waves-effect">Background</a></li>
                            <li><a class="waves-effect">Cells</a></li>
                            <li><a class="waves-effect">Links</a></li>
                            <li><a class="waves-effect">Nodes</a></li>
                            ${htmlbutton}
                        </ul>
                    </div>
                </li>
            </ul>
        </li>
    </ul>

    <button id="navlink"
            class="btn btn-small waves-effect waves-orange"
            data-activates="slide-out">
        <i class="material-icons">menu</i>
    </button>`;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/navigation/navigation-sidebar.html.js
// module id = 1033
// module chunks = 0